import axios from 'axios';
import { apiSettings, headers } from '../../app/conf';

export const getUserSettings = (userId, screen, token) => {
    const requestHeaders = {
        ...headers,
        Authorization: `Bearer ${token}`
    };
    const url = `${apiSettings}/user-settings/${userId}/${screen}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders
    });
};

export const saveUserSettings = (userId, screen, filters, token) => {
    const requestHeaders = {
        ...headers,
        Authorization: `Bearer ${token}`
    };
    const url = `${apiSettings}/user-settings/${userId}/${screen}`;
    return axios({
        method: 'put',
        url,
        headers: requestHeaders,
        data: { filters }
    });
};
